import polyglotI18nProvider from 'ra-i18n-polyglot';
import lodashGet from 'lodash/get';
import lodashMerge from 'lodash/merge'

import reactAdminHu from 'ra-language-hungarian';
import cmssHu from '~/languages/hu.json';
import { authenticationHu } from '@develnet/authentication';

import reactAdminEn from 'ra-language-english';
import cmssEn from '~/languages/en.json';
import { authenticationEn } from '@develnet/authentication';

const defaultLocale = 'en';
const translations = {
    'hu': getHungarianTranslation(),
    'en': getEnglishTranslation(),
}

const i18nProvider = polyglotI18nProvider(locale => {
        return lodashGet(translations, locale, translations[defaultLocale]);
    },
    defaultLocale
);

function getHungarianTranslation() {
    return mergeAll([reactAdminHu, cmssHu, authenticationHu]);
}

function getEnglishTranslation() {
    return mergeAll([reactAdminEn, cmssEn, authenticationEn]);
}

function mergeAll(objects) {
    if (objects.length == 0) {
        return {};
    }

    var merged = objects.shift();
    for (var obj of objects) {
        merged = lodashMerge(merged, obj);
    }
    return merged;
}

export default i18nProvider;